import { CheckIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { DefinitionTemplate } from './hooks/useCreateEvent';

export default function TemplateGrid({
    items,
    onSelect,
}: {
    items: DefinitionTemplate[];
    onSelect: (template: DefinitionTemplate) => void;
}) {
    return (
        <div className="flex flex-row mx-autogap-4 justify-center w-full">
            <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {items.map((template) => (
                    <li
                        key={template.name}
                        className="col-span-1 divide-y divide-gray-200 rounded-lg bg-[#fefefe] shadow hover:bg-[#fafafa]"
                    >
                        <div className="flex w-full items-top justify-between space-x-6 p-6 h-[180px] min-w-[300px]">
                            <div className="flex-1 truncate">
                                <div className="flex items-center space-x-3">
                                    <h3 className="truncate bold font-medium text-gray-900 pb-2">
                                        {template.name}
                                    </h3>
                                </div>
                                <p className="mt-1 text-wrap text-sm text-gray-500">
                                    {template.description}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="-mt-px flex divide-x divide-gray-200">
                                {template.demo && (
                                    <div className="flex w-0 flex-1">
                                        <a
                                            className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900"
                                            href={template.demo}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <VideoCameraIcon
                                                aria-hidden="true"
                                                className="size-5 text-gray-400"
                                            />
                                            Demo
                                        </a>
                                    </div>
                                )}
                                <div className="-ml-px flex w-0 flex-1 cursor-pointer">
                                    {/* eslint-disable-next-line */}
                                    <a
                                        className="relative inline-flex opacity-50 transition-opacity duration-300 hover:opacity-100 w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900"
                                        onClick={() => onSelect(template)}
                                    >
                                        <CheckIcon
                                            aria-hidden="true"
                                            className="size-5 text-gray-400"
                                        />
                                        Use
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
